export const fromFirestore = inUse => {
  return { ...inUse };
};

export const toFirestore = inUseToSave => {
  return {
    inUse: { ...inUseToSave },
  };
};
